import { FunctionalComponent, h } from 'preact';

import { AgentCard1Template } from 'desktop/module/agent/card-1/template';

import { AgentList1TemplatePropsInterface } from './template-props.interface';

/*/**
 * TODO-FE[WEB-1602]: Replace AgentList1TemplatePropsInterface with common agent list template props
 */
export const AgentList1Template: FunctionalComponent<AgentList1TemplatePropsInterface> = (props) => (
  <div>
    {!props.agents.length && <div>{props.noResultsMessage}</div>}
    {props.agents.length > 0 && (
      <ul className={`card-list ${props.disabled ? 'card-list--disabled' : ''}`}>
        {props.agents.map((agentCard, index) => (
          <li className='card-list__item'>
            <AgentCard1Template
              {...agentCard}
              onComponentDidMount={(element: HTMLElement) => agentCard.onCreateTemplate(element, index)}
            />
          </li>
        ))}
      </ul>
    )}
  </div>
);
